module.exports = __webpack_public_path__ + "img/gasbot-discord-logos.f7dbcd49.webp";